import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import _ from '@ihme/common/locale';

import {
    ABOUT_PATH,
    BREAKDOWN_PATH,
    COMMISSIONERS_AND_COLLABORATORS_PATH,
    DATA_MAPS_PATH,
    EVENTS_PATH,
    FACTSHEETS_PATH,
    GLOBAL_IMPACT_PATH,
    OUR_AIMS_PATH,
    SPONSORS_PATH,
    TEMPLATES_PATH,
    TRENDS_PATH,
    WOMEN_AND_CARDIOVASCULAR_DISEASE_COMMISSION_PATH,
} from '../../router/paths';

type Props = {};

type State = {
    isMenuOpen: boolean;
    isHeaderCollapsed: boolean;
};

class Header extends React.Component<Props, State> {
    state: State = {
        isMenuOpen: false,
        isHeaderCollapsed: false,
    };

    componentDidMount(): void {
        window.addEventListener('scroll', this.scrollHandler);
    }

    componentWillUnmount(): void {
        window.removeEventListener('scroll', this.scrollHandler);
    }

    scrollHandler = () => {
        const { isHeaderCollapsed } = this.state;

        const shouldHeaderCollapse = window.scrollY > 50;
        if (shouldHeaderCollapse === isHeaderCollapsed) {
            return;
        }

        if (isHeaderCollapsed) {
            this.removeBodyClass('scroll');
        } else {
            this.addBodyClass('scroll');
        }

        this.setState((state: State) => ({
            isHeaderCollapsed: !state.isHeaderCollapsed,
        }));
    };

    toggleMenu = () => {
        if (this.state.isMenuOpen) {
            this.removeBodyClass('menu-open');
        } else {
            this.addBodyClass('menu-open');
        }

        this.setState((state: State) => ({
            isMenuOpen: !state.isMenuOpen,
        }));
    };

    addBodyClass = (className: string) => {
        const body = document.body;
        body.classList.add(className);
    };

    removeBodyClass = (className: string) => {
        const body = document.body;
        body.classList.remove(className);
    };

    render() {
        return (
            <header id="siteHeader" className="sticky-header sticky-header--slide-down animated">
                <a href={WOMEN_AND_CARDIOVASCULAR_DISEASE_COMMISSION_PATH} className="logo">
                    <img
                        src="https://womencvdcommission.org/wp-content/themes/cvd-theme/dist/images/logo.png"
                        alt="Women And Cardiovascular Disease Commission"
                        className="site-logo__image"
                    />
                </a>
                <div className="menu-trigger-button" onClick={this.toggleMenu}>
                    •••
                </div>
                <ul className="menu-dropdown">
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-13">
                        <a href="#">{_('navigation_about')}</a>
                        <ul className="sub-menu">
                            <li
                                id="menu-item-487"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-487"
                            >
                                <a href={ABOUT_PATH}>About the Project</a>
                            </li>
                            <li
                                id="menu-item-221"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-221"
                            >
                                <a href={OUR_AIMS_PATH}>{_('navigation_our_aims')}</a>
                            </li>
                            <li
                                id="menu-item-73"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-73"
                            >
                                <a href={COMMISSIONERS_AND_COLLABORATORS_PATH}>
                                    {_('navigation_commissioners_and_contributors')}
                                </a>
                            </li>
                            <li
                                id="menu-item-72"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-72"
                            >
                                <a href={SPONSORS_PATH}>{_('navigation_sponsors')}</a>
                            </li>
                        </ul>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-16">
                        <a href="#">{_('navigation_resources')}</a>
                        <ul className="sub-menu">
                            <li
                                id="menu-item-233"
                                className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-224 current_page_item menu-item-233"
                            >
                                <a href={TEMPLATES_PATH} aria-current="page">
                                    {_('navigation_templates')}
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li
                        id="menu-item-14"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-14"
                    >
                        <a href={EVENTS_PATH}>{_('navigation_events')}</a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-232">
                        <a href={DATA_MAPS_PATH}>{_('navigation_data_maps')}</a>
                        <ul className="sub-menu">
                            <li className="menu-item">
                                <Link to={GLOBAL_IMPACT_PATH}>{_('navigation_global_impact')}</Link>
                            </li>
                            <li className="menu-item">
                                <Link to={TRENDS_PATH}>{_('navigation_trends')}</Link>
                            </li>
                            <li className="menu-item">
                                <Link to={BREAKDOWN_PATH}>{_('navigation_breakdown')}</Link>
                            </li>
                            <li className="menu-item">
                                <Link to={FACTSHEETS_PATH}>{_('navigation_factsheets')}</Link>
                            </li>
                        </ul>
                    </li>
                    <li className="menu-button menu-item menu-item-type-custom menu-item-object-custom menu-item-29">
                        <a
                            href="https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)00684-X/fulltext?dgcid=commweb_resources_lancetwomencvd21"
                            target="_blank"
                        >
                            VIEW THE LANCET COMMISSION REPORT
                        </a>
                    </li>
                </ul>
            </header>
        );
    }
}

export default withRouter(Header);
